export default __webpack_public_path__ + "static/media/menu-iconx.64a47fea.png";